var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 17,
    viewBox: "0 0 25 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5371 0H3.11416C1.87641 0 0.873047 0.95138 0.873047 2.125V14.875C0.873047 16.0486 1.87641 17 3.11416 17H22.5371C23.7749 17 24.7782 16.0486 24.7782 14.875V2.125C24.7782 0.95138 23.7749 0 22.5371 0ZM22.5371 2.125V3.93147C21.4902 4.73981 19.8213 5.99675 16.2533 8.64587C15.467 9.23233 13.9094 10.6412 12.8256 10.6248C11.7421 10.6414 10.184 9.23211 9.39799 8.64587C5.83057 5.99715 4.16117 4.73994 3.11416 3.93147V2.125H22.5371ZM3.11416 14.875V6.65824C4.18401 7.46623 5.70119 8.60005 8.01369 10.3171C9.03419 11.0787 10.8213 12.7602 12.8256 12.75C14.8201 12.7602 16.5846 11.1031 17.6372 10.3174C19.9496 8.60045 21.4672 7.46632 22.5371 6.65829V14.875H3.11416Z",
    fill: "#707070"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/Mail.d77ffa77.svg";
export { ForwardRef as ReactComponent };